var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-pm-gnb-dataQuery-tree"},[_c('ejs-listview',{ref:"reportTask",attrs:{"dataSource":_vm.taskDatas,"fields":_vm.fieldsReportTaskName,"select":_vm.nodeSelectedOfTaskId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }